module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagev",
      "title": "v"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/p01"
    }
  }, [_vm._v("PART ONE: THE FINAL SOLUTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/p01#p01"
    }
  }, [_vm._v("Prelude:        Hitler’s pledge: ‘The complete annihilation of the Jews’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01"
    }
  }, [_vm._v("Chapter 1     Humanity versus high policy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02"
    }
  }, [_vm._v("Chapter 2     Warnings and forebodings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03"
    }
  }, [_vm._v("Chapter 3     Britain’s dilemma")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04"
    }
  }, [_vm._v("Chapter 4     ‘Unbelievable crimes’: May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5     Evidence and omissions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6     ‘Camps are being prepared’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7     Towards ‘an unknown destination’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8     Rescue and refuge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9     Slaughter in the east")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10   Eye-witness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11   ‘This bestial policy’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART TWO: HOPE AND HOPELESSNESS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c12#c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12   ‘Everything has to be tried’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13   Rescue and massacre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14   Warsaw and Bermuda")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15   The debate of 19   May 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16   ‘I have never forgotten the terrible sufferings…’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17   The spread of Nazi power")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18   ‘A quite unmanageable flood’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19   Towards a second front")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20   The German occupation of Hungary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART THREE: AUSCHWITZ REVEALED")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c21#c21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21   Escape from Auschwitz, April 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22   Zionism at bay: rescue at risk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23   The deportations from Hungary, May 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24   A Gestapo offer: ‘Unmanageable numbers’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25   The truth about Auschwitz reaches the west, June 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26   The Gestapo offer: ‘Keep the pot boiling’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27   ‘Do all in your power’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28   ‘Get anything out of the Air Force you can’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29   ‘The biggest outcry possible’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30   Fears of a flood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31   Bombing Auschwitz: ‘Cost… to no purpose’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32   ‘These wailing Jews’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33   The end of Auschwitz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34   ‘The worst of all the camps’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biographical Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/adc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Books by Martin Gilbert")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340136e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 66
// module chunks = 0